import {Directive, ElementRef, HostListener, Input, Renderer2} from '@angular/core';

@Directive({
  selector: '[exgPreventDefault]'
})
export class ExgPreventDefaultDirective {

  @HostListener('keydown.enter', ['$event'])
  prevent(event: any): any {
    if (event.keyCode === 13) {
      event.preventDefault();
      return false;
    }
  }

  constructor() {
  }

}
